import { chartColors } from '@components/charts';
import React from 'react';

export const UsersHealthSidebar = ({ data }: { data: any }) => {
  const total = Object.values(data).reduce((a: number, b: any) => a + b, 0);

  console.log(data);

  const items = [
    { label: 'Active', value: data.active || 0, color: chartColors[1] },
    {
      label: 'Pending',
      value: data.approvalPending || 0,
      color: chartColors[2],
    },
    { label: 'Blocked', value: data.blocked || 0, color: chartColors[3] },
  ];

  return (
    <div className="rounded-2xl p-4 border dark:border-gray-700">
      {/* TITLE */}
      <div className="text-sm font-medium mb-2">Users Health</div>

      {/* KPI */}
      <div className="text-2xl font-semibold mb-3">{total}</div>

      {/* STACKED BAR */}
      <div className="w-full h-3 flex rounded overflow-hidden mb-3">
        {items.map((item) => {
          const percent = total > 0 ? (item.value / total) * 100 : 0;

          return (
            <div
              key={item.label}
              style={{
                width: `${percent}%`,
                backgroundColor: item.color,
              }}
            />
          );
        })}
      </div>

      {/* DETAILS */}
      <div className="flex flex-col gap-2 text-sm">
        {items.map((item) => (
          <div className="flex justify-between" key={item.label}>
            <span className="flex items-center gap-2">
              <span
                className="size-2 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              {item.label}
            </span>
            <span className="text-zinc-500">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
